import { QrCode } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  CreateDocumentsModal,
  SaveFolderModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithSearchLayout } from 'modules/components/layer32';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { theme } from 'theme';
import * as ds from './dataService';



export type FolderHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: FolderHeaderSectionProps) => {
  const params = useParams();
  const { data } = ds.useQuery(params.folderId ?? '');
  return (
    <ActivityHeaderSectionWithSearchLayout.FC
      title={data.name ?? ''}
      subtitle='Folder'
      actionButtons={(
        <ActionButtonsGroup
          projectId={params.projectId ?? ''}
          folderId={params.folderId ?? ''}
        />
      )}
      searchBar={<></>}
      backButton={<></>}
      overideReturnPath='../../files'
    />
  );
};



type ActionButtonsGroupProps = {
  projectId: string;
  folderId: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroupProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isUploadDocumentVisible,
    setIsUploadDocumentVisible
  ] = useState(false);
  const folderAccess = useAccessState('Folder');
  const documentAccess = useAccessState('Document');

  return (
    <>
      <Button
        startIcon={(
          <QrCode />
        )}
        disabled={!folderAccess.create}
        onClick={() => {
          const url = new URL(window.location.origin);
          url.pathname = `/external/${props.projectId}/share/folder/${props.folderId}`;
          window.open(url, '_blank', 'popup,width=900,height=700,menubar=0');
        }}
      >
        View QR Code
      </Button>

      {isVisible && (
        <SaveFolderModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}

      {isUploadDocumentVisible && (
        <CreateDocumentsModal.FC
          id=''
          isVisible={isUploadDocumentVisible}
          handleClose={() => setIsUploadDocumentVisible(() => false)}
        />
      )}

      <Button
        variant='contained'
        color='primary'
        onClick={() => setIsUploadDocumentVisible(() => true)}
        disabled={!documentAccess.create}
        startIcon={(
          <CustomIcon.large.FC
            icon='UPLOAD'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Upload Files
      </Button>

    </>
  );
};
